<template>
  <div class="modal-container">
    <Modal
      :isOpen="modalIsOpen"
      :description="content"
      :actionLabel="close_label"
      @closeModal="_closeModal"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Modal from "@/components/Modal";

export default {
  name: "ModalContainer",
  data() {
    return {
      modalIsOpen: false
    };
  },
  components: {
    Modal
  },
  computed: {
    ...mapState({
      modalData: state => state.modalData
    }),
    content: function() {
      return this.modalData.content;
    },
    close_label: function() {
      return this.modalData.close_label;
    }
  },
  methods: {
    ...mapActions({
      clearModalData: "clearModalData"
    }),
    _closeModal: function() {
      this.modalIsOpen = false;
      setTimeout(() => {
        this.clearModalData();
      }, 300);
    }
  },
  watch: {
    modalData: function(val) {
      if (val.content !== "" && val.close_label !== "") {
        this.modalIsOpen = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-container {
  display: block;
}
</style>
